export class PlanModel {
  constructor(id, name, description, price, validity, freeMinutesPerDay, freeMinutesPerPeriod, tenant, bikeTypeId, excludeInactiveMonths) {
    this.id = id || null;
    this.name = name || null;
    this.description = description || null;
    this.tenant = tenant || null;
    this.validity = validity || null;
    this.price = price === undefined ? null : price;
    this.freeMinutesPerDay = freeMinutesPerDay === undefined ? null : freeMinutesPerDay;
    this.freeMinutesPerPeriod = freeMinutesPerPeriod === undefined ? null : freeMinutesPerPeriod;
    this.bikeTypeId = bikeTypeId || null;
    this.excludeInactiveMonths = excludeInactiveMonths || false;
  }
}

export const PlanValidityTypes = Object.freeze({
  daily: { value: 'daily' },
  eightHours: { value: 'eightHours' },
  twelveHours: { value: 'twelveHours' },
  twentyFourHours: { value: 'twentyFourHours' },
  monthly: { value: 'monthly' },
  quarterly: { value: 'quarterly' },
  semiAnnual: { value: 'semiAnnual' },
  annualy: { value: 'annualy' },
});
